import { FC } from 'react';
import { IPropsArticle } from '../../common/articles';

interface IArticleComponentProps {
	article: IPropsArticle;
}

export const ArticleComponent: FC<IArticleComponentProps> = ({ article }) => {
	return <div>{article?.content}</div>;
};
